<template lang='pug'>
  v-flex(:class="classObj", :title='component.label' xs12 sm12 ma-4)
    v-select.v-select-image.ma-0.pa-0(
      v-model='data'
      :items='items'
      :multiple="component.multiple || true"
      label='Selecione a imagem a ser analisada'
      :placeholder="component.placeholder"
      :required="component.required"
      :disabled="component.disabled"
      clearable=true,
      small-chips
      hide-details
      :return-object="false"
      @change="onChange"
      :menu-props="{ 'content-class': 'v-select-image' }"
    )
      template(v-slot:selection="{ item }")
        v-card(:style="setImageStyle")
          v-chip(v-if="component.hiddenPreview") 1 Imagem selecionada
          v-img(v-else).v-select-image-selection(:src="item.url", alt="Selected Image")
            template(v-slot:placeholder="")
              v-layout.fill-height.align-center.justify-center.ma-0
              v-chip Carregando imagem..
      template(v-slot:item="{ item }")
        img.v-select-image-item(:src="item.url", alt="Select Image")
  </template>

  <script>
  import { mapState } from 'vuex'

  const IMAGE_URL_BASE = 'https://app.ultrahealth.care/functions/healthcareImage?id='

  export default {
    name: 'u-select-image',

    props: {
      id: {
        type: String
      },
      component: {
        type: Object,
        required: true
      },
      resultForm: {
        type: Object
      },
      value: {},
      imageStyle: {
        type: String
      }
    },

    computed: {
      ...mapState({
        company: (state) => state.ultraFetal.company,
        dicomParams: (state) => state.ultraFetal.dicomParams
      }),
      items () {
        return this.dicomParams.map(item => {
          return {
            value: item.iuid,
            text: item.info.instanceUid,
            url: IMAGE_URL_BASE + item.iuid + '&width=300px'
          }
        })
      },
      label () {
        return this.t(this.id + '.label', this.component.label)
      },
      setImageStyle () {
        return this.imageStyle || this.component.imageStyle || 'width: 100%;'
      }
    },

    watch: {
      value (val) {
        this.data = val
      },
      data (val) {
      }
    },

    data () {
      return {
        loading: false,
        data: null,
        editing: null,
        index: -1
      }
    }
  }
  </script>

  <style>
  .v-select-image-selection {
    width: 100%;
    height: 100%;
    min-height: 40px;
    object-fit: contain;
    background-color: black;
  }
  .v-select-image-item {
    object-fit: contain;
    width: 100%;
    height: 100%;
    background-color: black;
  }
  .v-select-image .v-list__tile--link {
    height: 210px !important;
  }
  .v-select-image .v-select__selections {
    padding: 7px;
  }
  .v-card-image-item{
    width: 100%;
  }
  </style>



// WEBPACK FOOTER //
// src/components/form/inputs/SelectImage.vue